import {
  Component,
  Input,
  ViewChild,
  OnChanges,
  Output,
  EventEmitter,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {
  MatTable as MatTable,
  MatTableDataSource as MatTableDataSource,
} from '@angular/material/table';
import { CategoriesItem, PointOfInterest } from './categories.model';
import { SubcategoryService } from '../subcategory/subcategory.service';
import { RootcategoriesService } from '../rootcategories/rootcategories.service';
import { NodeService } from '../../services/node-service/node-service.service';
import { RootCategoriesDataSource } from '../rootcategories/rootcategories-datasource';
import { Subscription } from 'rxjs';
import { PointsOfInterestDataSource } from '../points-of-interest/points-of-interest-datasource';
import { BasePaginatedResponse } from '../paginated/base.paginated.response.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { PointsOfInterestService } from '../points-of-interest/points-of-interest.service';
import { Router } from '@angular/router';
import { DeleteConfirmComponent } from '../delete-confirm/delete-confirm.component';
import { PoiProfileService } from '../poi-profile/poi-profile.service';
import { AppConfigService } from '../../auth/services/app-config.service';
import { MassDeleteComponent } from '../dialog-mass-delete/mass-delete.component';

const CATEGORY = 'category';
const COLUMNS = 'columns';
const ID = 'id';
const DATA = 'data';
const STATUS_OK = 200;

export interface Poi {
  id: number;
  nombre: string;
  children: [];
}

export interface SubCategorie {
  id: number;
  nombre: string;
  children: Poi[];
}

export interface Categorie {
  id: number;
  nombre: string;
  children: SubCategorie[];
}

export interface PoisGroup {
  id: number;
  nombre: string;
  children: Categorie[];
}

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css'],
  standalone: false,
})
export class CategoriesComponent implements OnChanges, AfterViewInit {
  @Input(ID) id!: number | undefined;
  @Input() initialDataSourceData!: any[];
  @Input(CATEGORY) categories: string = 'category';
  @Input(COLUMNS) displayedColumns = ['id', 'nombre', 'direccion_completa', 'actions'];
  @Input() listPois: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatTable, { static: false }) table!: MatTable<CategoriesItem | PointOfInterest>;

  @Output() parent_id$ = new EventEmitter<number>();

  dataSource!: MatTableDataSource<any>;
  dataRoot!: RootCategoriesDataSource;
  dataPois!: PointsOfInterestDataSource;
  routerLink: string = '/';
  suscription!: Subscription;
  subscriptionCategoriesList: Subscription = new Subscription();
  poisToBeChanged: number[] = [];
  poisToBeDeleted: number[] = [];
  subscriptionPoisMove: Subscription = new Subscription();
  eventChecked: boolean = false;
  events: any[] = [];
  selectAllCheckbox: boolean = false;
  loadTable: boolean = false;
  poiId!: number;
  datasourceDataLenght: number = 0;
  totalPages: number = 0;
  routerLinkEdit: string = './poi';
  testTable: boolean = false;
  pageSize: number = 10;
  pageIndex: number = 0;

  constructor(
    private subCategoryService: SubcategoryService,
    private rootService: RootcategoriesService,
    private nodeService: NodeService,
    public dialog: MatDialog,
    private pointsOfInterestService: PointsOfInterestService,
    private router: Router,
    private paginatorLang: MatPaginatorIntl,
    private poiProfileService: PoiProfileService,
    private cdr: ChangeDetectorRef,
    private appConfig: AppConfigService
  ) {
    this.paginatorLang.itemsPerPageLabel = 'Registros por página';
    this.dataSource = new MatTableDataSource<any>([]);
  }

  ngAfterViewInit() {
    if (this.initialDataSourceData && this.initialDataSourceData.length > 0) {
      this.loadTable = true;
      if (this.listPois) {
        this.generatePoisDataFromInput(this.initialDataSourceData);
      } else {
        this.generateSubCategory(this.initialDataSourceData);
      }
      this.cdr.detectChanges();
    } else if (!this.testTable) {
      this.loadData();
    }

    if (this.dataSource) {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    }
  }

  ngOnChanges(): void {
    // Si se proveen datos iniciales directamente, úsalos y sal de la función.
    if (this.initialDataSourceData && this.initialDataSourceData.length > 0) {
      this.loadTable = true;
      if (this.listPois) {
        this.generatePoisDataFromInput(this.initialDataSourceData);
      } else {
        this.generateSubCategory(this.initialDataSourceData);
      }
      return; // Importante: Salir después de procesar initialDataSourceData
    }

    // Si no se proveen datos iniciales, decide si cargar datos por ID o como categoría raíz.
    // Solo carga si hay un ID o si es la categoría 'root' sin ID específico.
    if (
      (this.id !== undefined && this.id !== null) ||
      (this.categories === 'category' && (this.id === undefined || this.id === null))
    ) {
      this.loadData();
    }
    // Si ninguna de las condiciones anteriores se cumple, significa que no hay datos válidos para cargar.
    else {
      console.warn(
        'CategoriesComponent: No valid ID or initial data provided. Skipping data load.'
      );
      this.loadTable = false;
    }
  }

  loadData(): void {
    this.loadTable = false;
    if (this.id !== undefined && this.id !== null) {
      this.subCategoryService.getCategory(this.id).subscribe({
        next: ({ body }) => {
          if (body.label === 'pois') {
            this.listPois = true;
            this.displayedColumns = [
              'checkbox_cambio',
              'id',
              'nombre_pois',
              'direccion_completa',
              'created_at',
              'actions',
            ];
            this.routerLink = './';
            this.nodeService.setPois(body.body);
            this.datasourceDataLenght = body.body?.length || 0;
            this.loadTable = true;
            this.generatePois();
          } else {
            this.listPois = false;
            this.displayedColumns = [
              'id',
              'nombre',
              'parent',
              'pois_count',
              'fuente',
              'red',
              'created_at',
              'actions',
            ];
            console.log('body.body (subcategories):', body.body);
            this.datasourceDataLenght = body.body?.length || 0;
            this.loadTable = true;
            this.generateSubCategory(body.body);
          }
        },
        error: (error) => {
          console.error('Error al cargar datos de categoría/subcategoría:', error);
          this.rootService.openSnacBar('Ha ocurrido un error al cargar los datos.');
          this.loadTable = false;
        },
      });
    } else if (this.categories === 'category' && (this.id === undefined || this.id === null)) {
      this.rootService.loadCategories().subscribe({
        next: ({ body }) => {
          if (body.label === 'parent') {
            this.datasourceDataLenght = body.body.length;
            this.loadTable = true;
            this.generateRootCategory(body.body);
          }
        },
        error: (error) => {
          console.error('Error al cargar categorías raíz:', error);
          this.rootService.openSnacBar('Ha ocurrido un error al cargar las categorías raíz');
          this.loadTable = false;
        },
      });
    }
  }

  /**
   * Se ejecuta cuando el usuario cambia de página en `mat-paginator`
   */
  onPageChange(event: PageEvent) {
    if (this.listPois) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
      this.generatePois();
    }
  }

  openDialogToDelete(row: any) {
    const dialogRef = this.dialog.open(DeleteConfirmComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) this.deletePoiClick(row);
    });
  }

  deletePoiClick(row: any): void {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.onSameUrlNavigation = 'reload';

    if (this.listPois) {
      this.poiProfileService.deletePoi(row.id).subscribe({
        next: (res) => {
          this.nodeService.setPois(this.nodeService.getPois().filter((poi) => poi.id !== row.id));
          this.rootService.openSnacBar('Pois eliminado');
          this.router.navigate(['/', 'category', row.categoryId]);
        },
        error: (error) => {
          console.error('Error al eliminar POI:', error);
          this.rootService.openSnacBar('Ha ocurrido un error al eliminar el POI.');
        },
      });
    } else {
      this.subCategoryService.deleteCat(row.id).subscribe({
        next: (res) => {
          this.rootService.openSnacBar('Categoria eliminada');
          if (row.parentId) {
            this.router.navigate(['/', 'category', row.parentId]);
          } else {
            this.router.navigate(['/', 'categories']);
          }
        },
        error: (error) => {
          console.error('Error al eliminar categoría:', error);
          this.rootService.openSnacBar('Ha ocurrido un error al eliminar la categoría.');
        },
      });
    }
  }

  openMassDelete() {
    const massDeleteRef = this.dialog.open(MassDeleteComponent);

    massDeleteRef.afterClosed().subscribe((result) => {
      if (result) {
        const listPoisToDelete = massDeleteRef.componentInstance.poisToDelete;
        this.poiProfileService.massivePoiDelete(listPoisToDelete).subscribe({
          next: (resp) => {
            this.nodeService.setPois(
              this.nodeService.getPois().filter((poi) => !listPoisToDelete.includes(poi.id))
            );
            this.rootService.openSnacBar('Operación realizada con éxito');
            this.router.routeReuseStrategy.shouldReuseRoute = function () {
              return false;
            };
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate([`categories/category/${this.id}`]);
          },
          error: (error) => {
            console.error('Error al eliminar POIs masivamente:', error);
            this.rootService.openSnacBar('Ha ocurrido un error al eliminar los pois seleccionados');
          },
        });
      }
    });
  }

  removeAllPois() {
    const dialogRef = this.dialog.open(DeleteConfirmComponent);
    dialogRef.afterClosed().subscribe((result) => {
      this.rootService.openSnacBar('Aguarde un instante mientras borramos los puntos de interés.');
      if (result) {
        if (this.id !== undefined && this.id !== null) {
          const poisDeletedBycategoryId = this.id;
          this.poiProfileService.removeAllPois(poisDeletedBycategoryId).subscribe({
            next: (resp) => {
              this.rootService.openSnacBar('Operación realizada con éxito');
              this.router.navigate([`categories/category/${this.id}`]);
            },
            error: (error) => {
              console.error('Error al eliminar todos los POIs:', error);
              this.rootService.openSnacBar('Ha ocurrido un error al eliminar todos los pois.');
            },
          });
        } else {
          this.rootService.openSnacBar(
            'No se pudo realizar la operación. El ID de la categoría no está disponible.'
          );
        }
      }
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        const categoryId = this.nodeService.getDestinantionCategory();

        if (categoryId === 0) {
          return this.rootService.openSnacBar('No se ha seleccionado una categoría de destino');
        }

        const data: any = this.poisToBeChanged.map((item) => ({
          id: item,
          categoryId: categoryId,
        }));

        this.pointsOfInterestService.sendPoisToMove(data).subscribe({
          next: (resp) => {
            if (resp.status === STATUS_OK) {
              this.nodeService.setDestinationCategory(0);
              this.rootService.openSnacBar('Operación realizada con éxito');
              this.router.routeReuseStrategy.shouldReuseRoute = function () {
                return false;
              };
              this.router.onSameUrlNavigation = 'reload';
              this.router.navigate([`categories/category/${categoryId}`]);
            } else {
              this.rootService.openSnacBar('Ha ocurrido un error al mover los pois seleccionados');
            }
          },
          error: (error) => {
            console.error('Error al mover POIs:', error);
            this.rootService.openSnacBar('Ha ocurrido un error al mover los pois seleccionados');
          },
        });
      }
    });
  }

  applyFilter(event: Event) {
    const target = event.target as HTMLButtonElement;
    let filterValue = target.value;
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();

    if (this.dataSource) {
      this.dataSource.filter = filterValue;
    }

    if (this.dataRoot) {
      this.dataRoot.filter = filterValue;
    }

    if (this.dataPois) {
      this.dataPois.filter = filterValue;
    }
  }

  generatePoisDataFromInput(data: PointOfInterest[]): void {
    this.dataSource.data = data;
    this.dataPois = new PointsOfInterestDataSource(data);
    this.totalPages =
      this.dataPois.data.length > 0 ? Math.ceil(this.dataPois.data.length / this.pageSize) : 0;
    if (this.table) {
      this.table.dataSource = this.dataPois;
    }
    this.categories = `poi`;
    this.datasourceDataLenght = data.length;
    this.cdr.detectChanges();
    setTimeout(() => {
      if (this.paginator) {
        this.dataPois.sort = this.sort;
        this.paginator.length = data.length;
        this.cdr.detectChanges();
      }
    }, 0);
  }

  generatePois(): void {
    if (this.id !== undefined && this.id !== null) {
      this.subCategoryService.getPoisPaginated(this.id, this.pageIndex, this.pageSize).subscribe({
        next: (response: BasePaginatedResponse<PointOfInterest>) => {
          this.dataSource.data = response.content;
          this.dataPois = new PointsOfInterestDataSource(response.content);
          this.totalPages = response.totalPages;
          if (this.table) {
            this.table.dataSource = this.dataPois;
          }
          this.categories = `poi`;
          this.datasourceDataLenght = response.totalElements;
          this.cdr.detectChanges();
          setTimeout(() => {
            if (this.paginator) {
              this.dataPois.sort = this.sort;
              this.paginator.length = response.totalElements;
              this.cdr.detectChanges();
            }
          }, 0);
        },
        error: (error) => {
          console.error('Error al generar POIs paginados:', error);
          this.rootService.openSnacBar('Ha ocurrido un error al cargar los POIs paginados.');
          this.loadTable = false;
        },
      });
    } else {
      console.warn(
        'generatePois: ID de categoría no disponible. No se realizará la llamada a getPoisPaginated.'
      );
      this.loadTable = false;
    }
  }

  generateSubCategory(data: CategoriesItem[]): void {
    this.dataSource = new MatTableDataSource<CategoriesItem>(data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    if (this.table) {
      this.table.dataSource = this.dataSource;
    }
    this.datasourceDataLenght = data.length;
    this.cdr.detectChanges();
  }

  generateRootCategory(data: CategoriesItem[]): void {
    this.nodeService.setCategories(data);
    this.dataRoot = new RootCategoriesDataSource(data);
    this.dataRoot.sort = this.sort;
    this.dataRoot.paginator = this.paginator;
    if (this.table) {
      this.table.dataSource = this.dataRoot;
    }
    this.datasourceDataLenght = data.length;
    this.cdr.detectChanges();
  }

  setDataToEdit(row: any): void {
    if (this.categories === 'poi') {
      this.nodeService.setPoiToEdit(row);
    } else {
      this.nodeService.setCategoryToEdit(row);
    }
  }

  showOptions(event: MatCheckboxChange, poisId: any): void {
    if (event.checked === true) {
      this.addPoisToBeChanged(poisId);
      this.eventChecked = true;
      this.handleCheck(poisId, true);
    } else {
      this.deletePoisToBeChanged(poisId);
      this.handleCheck(poisId, false);
    }
  }

  handleCheck(id: number, checked: boolean): void {
    const exits = this.events.some((item) => item.id === id);

    if (exits) {
      this.events.filter((item) => item.id === id).forEach((item) => (item.checked = checked));
    }

    this.events.push({ id, checked });

    this.eventChecked = this.events.some((item) => item.checked === true);
  }

  setAllCheckbox(isChecked: boolean) {
    this.events.forEach((item) => (item.checked = isChecked));

    this.selectAllCheckbox = !this.selectAllCheckbox;

    if (this.selectAllCheckbox) {
      const newData = this.dataPois.filteredData.map((item) => item.id);

      this.poisToBeChanged = newData;

      this.nodeService.setPoisToMove(newData);

      this.eventChecked = true;
    } else {
      this.eventChecked = false;
      this.nodeService.setPoisToMove([]);
      this.poisToBeChanged = [];
    }
  }

  addPoisToBeChanged(poisId: number): void {
    this.poisToBeChanged.push(poisId);
    this.poisToBeChanged = Array.from(new Set(this.poisToBeChanged));
    this.nodeService.setPoisToMove(this.poisToBeChanged);
  }

  deletePoisToBeChanged(poisId: any): void {
    this.poisToBeChanged = this.poisToBeChanged.filter((currentPoisId) => currentPoisId !== poisId);
    this.nodeService.setPoisToMove(this.poisToBeChanged);
  }

  iconErrorHandler(event: any) {
    event.target.src = this.appConfig.config.baseHref + this.appConfig.config.defaultIcon64;
  }

  markerErrorHandler(event: any) {
    event.target.src = this.appConfig.config.baseHref + this.appConfig.config.defaultMarker64;
  }
}
